import React, { useState, useEffect } from "react";
import "./About.scss";
import { motion } from "framer-motion";
import { AppWrap, MotionWrap } from "../../wrapper";
import Typewriter from "typewriter-effect";
import { urlFor, client } from "../../client";

const About = () => {
  const [abouts, setAbouts] = useState([]);
  useEffect(() => {
    const query = '*[_type == "abouts"]';
    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);

  return (
    <>
      <div className="head-text">
        <div>My Quick Background</div>

        <div className="typewritter">
          <Typewriter
            options={{
              autoStart: true,
              loop: true,
            }}
            onInit={(typewriter) => {
              typewriter
                .typeString(`<span>IT Support</span>`)
                .pauseFor(1000)
                .deleteAll()
                .typeString(`<span>Data Center Operations</span>`)
                .pauseFor(1000)
                .deleteAll()
                .typeString(`<span>Linux</span>`)
                .pauseFor(1000)
                .deleteAll()
                .typeString(`<span>MERN stack</span>`)
                .pauseFor(1000)
                .deleteAll()
                .typeString(`<span>REST API</span>`)
                .pauseFor(1000)
                .deleteAll()
                .typeString(`<span>Continous Learning...</span>`)
                .pauseFor(1000)
                .deleteAll()
                .start();
            }}
          />
        </div>
      </div>
      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween" }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
